import { ZUS_SIGN_STATUS_LABELS, ZUS_SIGN_STATUS_VALUES } from '../../../constants-v2/bookkeeping/zus-declaration';
import declarationError from '../../../filters/zus/declaration-error';
import column from '../../abstract/column';
import vars from '../../abstract/vars';
import actions from './actions';
import api, { modelName } from './api';

export const signStatusOptions = {
  error: {
    label: ZUS_SIGN_STATUS_LABELS.ERROR,
    value: ZUS_SIGN_STATUS_VALUES.ERROR,
    color: 'danger',
  },
  wait: {
    label: ZUS_SIGN_STATUS_LABELS.WAIT,
    value: ZUS_SIGN_STATUS_VALUES.WAIT,
    color: 'warning',
  },
  added: {
    label: ZUS_SIGN_STATUS_LABELS.ADDED,
    value: ZUS_SIGN_STATUS_VALUES.ADDED,
    color: 'primary',
  },
  success: {
    label: ZUS_SIGN_STATUS_LABELS.SUCCESS,
    value: ZUS_SIGN_STATUS_VALUES.SUCCESS,
    color: 'success',
  },
  nostatus: {
    label: ZUS_SIGN_STATUS_LABELS.NOSTATUS,
    value: ZUS_SIGN_STATUS_VALUES.NOSTATUS,
    color: '#c8c8c8',
  },
  control: {
    label: ZUS_SIGN_STATUS_LABELS.CONTROL,
    value: ZUS_SIGN_STATUS_VALUES.CONTROL,
    color: 'warning',
  },
  investigation: {
    label: ZUS_SIGN_STATUS_LABELS.INVESTIGATION_PACKAGE,
    value: ZUS_SIGN_STATUS_VALUES.INVESTIGATION,
    color: 'warning',
  },
  errorPackage: {
    label: ZUS_SIGN_STATUS_LABELS.ERROR_PACKAGE,
    value: ZUS_SIGN_STATUS_VALUES.ERROR_PACKAGE,
    color: 'warning',
  },
};

export default {
  actions,
  api,
  modelName,
  sidebarData: {
    error: column({
      label: 'Błąd z ZUS',
      format: item => {
        return declarationError(item?.zusdeclarationspackages?.error);
      },
      size: 100,
    }),
    id: column({
      label: 'Identyfikator',
      size: 100,
    }),
  },
  columns: {
    document_index: column({ label: 'Identyfikator dokumentu' }),
    type: column({ label: 'Typ' }),
    created_at: column({ label: 'Data utworzenia' }),
    zus_package_index: column({ label: 'Identyfikator kompletu', format: item => item?.zusdeclarationspackages?.document_index }),
    sent_at: column({ label: 'Data wysyłki do ZUS', format: item => item?.zusdeclarationspackages?.sent_at }),
    sent_by: column({ label: 'Wysłano przez', format: item => item?.zusdeclarationspackages?.sent_by_name }),
    status: column({
      label: 'Status wysyłki',
      format: item => {
        if (item?.zusdeclarationspackages?.status) {
          return item?.zusdeclarationspackages?.status;
        }
        if (item?.zusdeclarationspackages?.task_index_package_in_zus) {
          return 'wait';
        }

        if (item?.zusdeclarationspackages?.id) {
          return 'added';
        }

        return 'nostatus';
      },
      options: signStatusOptions,
      component: 'value-status',
    }),
  },
  vars: vars({
    noItemsText: 'Brak deklaracji',
    sidebarLabel: 'Podgląd deklaracji',
  }),
  topRightActions: {
    create: {
      label: 'Dodaj deklarację',
      icon: 'icon-plus',
      handle: async ({ $router, $route }) => {
        let zuspackage_id = null;
        const filters = $route?.query?.filters;

        if (filters) {
          const parsed = JSON.parse(filters);
          zuspackage_id = parsed.filter(res => res.field === 'zusdeclarationspackages.id')[0]?.value || null;
        }

        let sufix = '';
        if (zuspackage_id) {
          sufix = `/${ zuspackage_id }`;
        }

        await $router.push(`/zus/declarations/add${ sufix }`);
      },
    },
  },
};
